import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAlert, FDBox, FDContentContainer, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import ReadOnlyField from 'Components/UI/Overrides/ReadOnlyField';

export const LeadFormLayout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();

  return (
    <FDBox paddingY={3}>
      <FDContentContainer maxWidth={'md'}>
        <FDStack direction={'column'} spacing={2}>
          <FDAlert
            title={'Before Submitting'}
            description={'Please understand the following before submitting'}
            status={'warning'}
            details={[
              'Leads created this way will only have a Planning Membership fee applied. This is correct for PX.',
              'Make sure to clear your visitorSessionUUID cookie before EACH submission',
              'After submitting, copy and send the link to prospect for them to complete purchase.',
            ]}
          />
          {resource.withRelationship(fr.relationships.newMembershipURL.name, (rel) => {
            return (<ReadOnlyField
              label={'Buy Page Link'}
              value={rel.link('related').url()}
            />);
          }, () => null)}
          <FDInputRow>
            <MetaControlField attr={'firstName'} />
            <MetaControlField attr={'lastName'} />
            <MetaControlField attr={'emailAddress'} />
            <MetaControlField attr={'phoneNumber'} />
            <MetaControlField attr={'paymentInterval'} />
            <MetaControlField attr={'serviceLevelCategory'} />
          </FDInputRow>
          <MetaLayoutVertical resource={resource} />
          <FDStack justifyContent={'flex-end'}>
            <FDPrimaryActionButton label={'Submit'} onClick={onSubmit} />
          </FDStack>
        </FDStack>
      </FDContentContainer>
    </FDBox>
  );
};
